export default function getResource(label, vars = []) {
    const resources = {
        checkoutInitializationFailed: 'Impossible d’initialiser le processus de paiement avec PayPal. Veuillez réessayer ou utiliser un autre mode de paiement.',
        orderPlacementFailed: 'Nous ne parvenons pas à passer votre commande. Veuillez réessayer ou utiliser un autre mode de paiement.',
        checkoutErrorTitle: 'Erreur de paiement avec PayPal',
        orderPlacementErrorTitle: 'Erreur dans la passation de commande',
        okButton: 'OK'
    };

    return resources[label];
}
